import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { ICommodityWaybillsDto } from "../dtos/iComodityWaybillsDto";
import { AppEntities } from "src/config/entities";
import { CommodityWaybillsService } from "src/services/documents/CommodityWaybillsService";
import { ICommodityWaybillsModel } from "../models/ICommodityWaybillsModel";
import { CommodityWaybillProductDto } from "../dtos/CommodityWaybillProductDto";
import { CommodityWaybillInformationDto } from "../dtos/CommodityWaybillInformationDto";


interface IProps {
    documentId?: string;
}

export const useFetchCommodityWaybills = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<ICommodityWaybillsDto | null>(null);
    const [documentModel, setDocumentModel] = useState<ICommodityWaybillsModel | null>(null);
    const dataService = AppEntities.CommodityWaybills.getDataService() as CommodityWaybillsService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: ICommodityWaybillsModel) => {
        if(!documentId) return;
        console.log(documentModel)
        const requestDto: ICommodityWaybillsDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

  
    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            let responseDto: ICommodityWaybillsDto | null = null;
            let responseCommodityWaybillProductsDto: CommodityWaybillProductDto[] = [];
            let responseCommodityWaybillInformationsDto:CommodityWaybillInformationDto[]=[]
            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: ICommodityWaybillsModel = {
                ...responseDto,
                commodityWaybillProducts: [...responseCommodityWaybillProductsDto],
                commodityWaybillInformations:[...responseCommodityWaybillInformationsDto]
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}
